module.exports = __webpack_public_path__ + "img/2.c3cca9a3.jpg";